_filterFacetValues